import section1 from "./360grad-matterport-service.jpg";
import header from "./Editing-360-Grad-Matterport-Service-02.jpg";
import section2 from "./Editing-360-Grad-Matterport-Service-03.jpg";
import section4 from "./Editing-360-Grad-Matterport-Service-04.jpg";
import section3 from "./grundrisse.png";

export { header, section1, section2, section3, section4 };
